import { getNextOnboardingPage, onboardingSteps } from "../util/profile_utils"

export const generateRedirectPath = (loggedIn, onboardingStep, name, open) => {
    // do not redirect if verifying email
    if (name === "verifyEmail" && onboardingStep != "2"){
        return null
    }
    
    const { steps } = onboardingSteps
    // get the page names as step names
    const onboardingStepNames = Object.keys(steps).map(key =>
        steps[key].page.replace("/", ""),
    )
    // check if we're currently on an onboarding page
    const isOnboardingPage = onboardingStepNames.indexOf(name) !== -1
    // check if we're logged in and the route is open
    const redirectToSignIn = !loggedIn && !open
    // redirect to dashboard from anywhere
    const redirectToDashboard =
        loggedIn &&
        open &&
        (name !== "verifyEmail" && name !== "acceptInvite") &&
        onboardingStep === "done"
    // redirect to dashboard from an onboarding step (edge case)
    const redirectToDashboardFromOnboarding =
        isOnboardingPage && loggedIn && onboardingStep === "done"
    // check if we're done with onboarding
    const redirectToOnboarding = loggedIn && onboardingStep !== "done"
    // calculate the redirect path for onboardingStep
    const onboardingPath =
        onboardingStep !== "done" &&
        onboardingStep !== "" &&
        getNextOnboardingPage(onboardingStep)
        
    if (redirectToSignIn) {
        return "/signIn"
    }
    if (redirectToDashboardFromOnboarding || redirectToDashboard) {
        return "/dashboard"
    }
    if (redirectToOnboarding && onboardingPath) {
        return onboardingPath === `/${name}` ? null : onboardingPath
    }
    return null
}



// WEBPACK FOOTER //
// ./src/util/router_utils.js